import CookieBannerConfiguration from "../models/CookieBannerConfiguration";
import CookieCategory from "../models/CookieCategory";

export default class CookieBannerMapper {
    public map(data: any) : CookieBannerConfiguration {
        const configuration : CookieBannerConfiguration = new CookieBannerConfiguration();

        configuration.title = data.Title;
        configuration.acceptButtonText = data.AcceptButtonText;
        configuration.otherSettingsButtonText = data.OtherSettingsButtonText;
        configuration.additionalInformation = data.AdditionalInformation;
        configuration.cookieAndPrivacyInformation = data.CookieAndPrivacyInformation;
        configuration.acceptOtherSettingsButtonText = data.AcceptOtherSettingsButtonText;
        configuration.acceptCategoryButtonText = data.AcceptCategoryButtonText;
        configuration.declineCategoryButtonText = data.DeclineCategoryButtonText;
        configuration.domain = data.Domain,

        configuration.cookieCategories = data.Categories.map((category : any) : CookieCategory => { return this.mapCookieCategory(category); });

        return configuration;
    }

    public mapCookieCategory(data: any) : CookieCategory {
        const category : CookieCategory = new CookieCategory();
        category.title = data.Title;
        category.description = data.Description;
        category.cookieName = data.CookieName;
        category.isRequired = data.IsRequired;
        category.hasConcent = data.IsRequired; //Only categories that are required have are "consent" by default, others don't
        return category;
    }
}